<template>
  <div class="submission-panel">
    <PxPanel class="submission-panel__container px-panel--xs-no-side-borders">
      <div class="submission-panel__grid-container">
        <SubmissionPanelAffiliate
          :affiliate="affiliate"
          :submission-date="submissionFormattedDate"
        />
        <SubmissionPanelSupporter
          :company="company"
          :submission="submission"
          :user-can-match="canMatch"
          @click="showListModal"
        />
      </div>
      <div class="submission-panel__tabs-container">
        <SubmissionPanelTabs :submission="submission" />
      </div>
    </PxPanel>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import moment from "moment";

import SubmissionPanelAffiliate from "@/modules/supporters/components/submission/submission-panel-affiliate.vue";
import SubmissionPanelSupporter from "@/modules/supporters/components/submission/submission-panel-supporter.vue";
import SubmissionPanelTabs from "@/modules/supporters/components/submission/submission-panel-tabs.vue";

import { ICompany } from "@/modules/profile/services/data/company/company.types";
import { IAffiliate } from "@/services/data/affiliate/affiliate.interface";

import { IAffiliateProgramSupporterSubmission } from "@/modules/supporters/services/data/affiliate-program-supporter-submission/affiliate-program-supporter-submission.interface";
import { IMatchingCriteria } from "@/modules/matching/services/data/matching-score/matching-criteria.interface";
import { ISupporter } from "@/modules/matching/services/data/matching-score/supporter.interface";

export default defineComponent({
  components: {
    SubmissionPanelAffiliate,
    SubmissionPanelSupporter,
    SubmissionPanelTabs,
  },

  props: {
    submission: {
      type: Object as () => IAffiliateProgramSupporterSubmission,
      required: true,
    },
  },

  data() {
    return {
      submissionUid: "",
    };
  },

  computed: {
    supporter(): ISupporter {
      return this.submission?.supporter;
    },

    company(): ICompany {
      return this.submission?.supporter?.user_profile?.company;
    },

    affiliate(): IAffiliate {
      return this.submission?.affiliate;
    },

    questions(): Array<IMatchingCriteria> {
      return this.submission?.criteria;
    },

    interests(): Array<IMatchingCriteria> {
      return this.submission?.additional_criteria;
    },

    profileCompany(): ICompany | null {
      return this.$store.state.profile.company.data;
    },

    profileCompanyId(): number | null {
      return this.profileCompany ? this.profileCompany.id : null;
    },

    submissionFormattedDate(): string {
      const date = this.submission
        ? moment(this.submission.created_at)
        : moment();
      return date.format("MMMM D, YYYY - HH:mmA");
    },
    canMatch(): boolean {
      return (
        (this.$store.state.matchingInterest.canMatch &&
          this.$user.isLogged()) ||
        false
      );
    },
  },
  methods: {
    showListModal() {
      this.$emit("click");
    },
  },
});
</script>

<style lang="scss" scoped>
.submission-panel__container,
.submission-tab__container {
  width: 100vw;
  margin: 0;
  overflow: hidden;

  @include breakpoint-up(lg) {
    width: 938px;
  }
}

.submission-panel__container {
  @include breakpoint-up(lg) {
    border-radius: 4px;
  }
}

.submission-panel__container :deep() .px-panel__body {
  padding: 0;
}

.submission-panel__grid-container {
  background-image: linear-gradient(
    to bottom,
    rgba(123, 183, 255, 0),
    rgba(123, 183, 255, 0.04)
  );

  &:not(:only-child) {
    padding-bottom: 73px;
  }
}

.submission-panel__tabs-container {
  border-top: solid 1px $mischka;
}
</style>
